import { render, staticRenderFns } from "./RefreshPage.vue?vue&type=template&id=1ebd4af0"
import script from "./RefreshPage.vue?vue&type=script&lang=js"
export * from "./RefreshPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/bamboo-agent-home/xml-data/build-dir/MEM-MEMUI-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ebd4af0')) {
      api.createRecord('1ebd4af0', component.options)
    } else {
      api.reload('1ebd4af0', component.options)
    }
    module.hot.accept("./RefreshPage.vue?vue&type=template&id=1ebd4af0", function () {
      api.rerender('1ebd4af0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/refresh/RefreshPage.vue"
export default component.exports